const CustomSelect = ({
  label,
  requiredMark,
  starMark,
  onChange,
  value,
  data,
  style,
  disable = false,
  font = 'bold'
}) => {
  const containerStyle = {
    width: '100%'
  };

  const labelStyle = {
    display: 'flex',
    fontSize: '14px',
    color: '#374151',
    justifyContent: 'flex-start',
    marginBottom: '8px',
    fontWeight: font === 'bold' ? '600' : '400'
  };

  const selectContainerStyle = {
    position: 'relative',
    width: '100%'
  };

  const selectStyle = {
    width: '100%',
    padding: '7px 11px',
    fontSize: '14px',
    border: '1px solid #e5e5ea',
    borderRadius: '6px',
    backgroundColor: disable ? '#F9FAFB' : '#FFFFFF',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'all 0.2s ease',
    cursor: disable ? 'not-allowed' : 'pointer',
    appearance: 'none',
    backgroundPosition: 'right 16px center',
    backgroundSize: '16px',
    color: value ? '#111827' : '#9CA3AF',
    lineHeight: 1.42857143,
    ...style
  };

  const optionStyle = {
    textTransform: 'capitalize',
    padding: '12px 16px',
    cursor: 'pointer'
  };

  return (
    <div style={containerStyle}>
      {label && (
        <label style={labelStyle}>
          {label}
          {(requiredMark || starMark) && (
            <span
              style={{ fontSize: '18px', color: '#EF4444', marginLeft: '4px' }}
            >
              *
            </span>
          )}
        </label>
      )}
      <div style={selectContainerStyle}>
        <select
          onChange={(e) => {
            onChange(e);
          }}
          value={value}
          disabled={disable}
          style={selectStyle}
        >
          <option value="" disabled style={optionStyle}>
            Select
          </option>

          {data?.map((option, index) => {
            return (
              <option value={option.value} key={index} style={optionStyle}>
                {option.label}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default CustomSelect;
